const lang = function(){
    let $lang = document.querySelector('.lang');
    let $name = $lang.querySelector('.lang__name');

    $name.addEventListener('click', function() {
        $lang.classList.toggle('is-active');
    });

    document.addEventListener("click", function (e) {
        if (e.target.closest(".lang")) return;
        $lang.classList.remove('is-active');
    });

};

export default lang();
